import { makeCall, POST } from '../utilities/CommonApiUtils';
import { ANALYTICS_EVENTS, trackEvent } from '../utilities/analytics';
import { SET_OKTA_ERROR } from '../constants/ApiConstants';

/**
 * Reports a denied sign in to analytics and to the backend logs, with the email
 * and time the login page shows, so support can find it from what the user tells
 * them. Fire and forget: the user is leaving the callback page and must not see
 * anything if the report fails.
 */
const reportAccessDenied = (error, { email, occurredAt, loginPath }) => {
  trackEvent(ANALYTICS_EVENTS.LOGIN_FAILED, {
    error_code: error.errorCode,
    error_message: error.errorSummary,
    login_path: loginPath,
  });
  makeCall(POST, SET_OKTA_ERROR, { error, email, occurredAt, loginPath });
};

export default reportAccessDenied;
